/**
 * Lead source options shown on the Add-Lead modals (staff + installer)
 * and used to bucket the Lead Sources card on the Analytics dashboard.
 *
 * `value` is what we store in MongoDB (stable, machine-readable). `label`
 * is what's shown in dropdowns and charts.
 *
 * Edit/extend cautiously — adding new entries is safe; renaming existing
 * `value` strings will orphan historical leads on the analytics breakdown.
 */
export const LEAD_SOURCES = [
  { value: 'google',           label: 'Google search' },
  { value: 'instagram',        label: 'Instagram' },
  { value: 'facebook',         label: 'Facebook' },
  { value: 'tiktok',           label: 'TikTok' },
  { value: 'referral',         label: 'Referral / word of mouth' },
  { value: 'returning',        label: 'Returning customer' },
  { value: 'website',          label: 'Website / direct' },
  { value: 'trade_show',       label: 'Trade show / event' },
  { value: 'leaflet',          label: 'Leaflet / flyer' },
  { value: 'vehicle_signage',  label: 'Saw the van' },
  { value: 'other',            label: 'Other' },
];

export const LEAD_SOURCE_LABEL = Object.fromEntries(
  LEAD_SOURCES.map((s) => [s.value, s.label]),
);
